(function() {
    'use strict';

    angular.module('app.moviles', []);
})();
